<template>
    <tr class="clickable-row">
        <td><a href="" @click.prevent.stop>{{subscription.fingerprint}}</a></td>
        <td><a href="" @click.prevent.stop>{{subscription.type.name}}</a></td>
        <td><a href="" @click.prevent.stop>{{getShortDateString(subscription.start_date)}}</a></td>
        <td><a href="" @click.prevent.stop>{{getShortDateString(subscription.expired_date)}}</a></td>

        <td><a href="" @click.prevent.stop><span :class="getClassLabelSubscriptionActive(subscription.is_active)" class="label">{{getStringSubscriptionActive(subscription.is_active)}}</span></a></td>

        <td v-if="subscription.type.unlimited_redeemable"><a href="" @click.prevent.stop>({{ $t('components.subscription_type.appointment_unlimited') }})</a></td>
        <td v-else><a href="" @click.prevent.stop>{{subscription.residual_redeemable_appointments}} {{ $t('components.subscription.residual_appointments') }}</a></td>

    </tr>
</template>

<script>
    import {Utils} from "../../common/utils";

export default {
    name: "SubscriptionRow",
    props: {
        subscription: {
            type: Object,
            require: true
        }
    },
    methods: {
        getShortDateString(date) {
            return Utils.getShortDateStringUTCFromISO(date)
        },
        getClassLabelSubscriptionActive(active) {
            return Utils.getClassLabelSubscriptionActive(active)
        },
        getStringSubscriptionActive(active) {
            return Utils.getStringSubscriptionActive(active)
        }
    }
};
</script>
